'use strict';

var borderRadii = {};

exports.__exports = borderRadii;
//# sourceMappingURL=borderRadii.cjs.map
